import { createCrudService } from './createCrudService';
import type { WorkflowDefinition } from './workflowDefinitionsService';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface WorkflowSchedule {
  id: string;
  tenant_id: number;
  workflow_definition_id: string;
  name: string;
  description: string | null;
  cron_expression: string;
  timezone: string | null;
  is_active: boolean;
  input_data: Record<string, unknown> | null;
  options: Record<string, unknown> | null;
  last_triggered_at: string | null;
  next_run_at: string | null;
  created_at: string;
  updated_at: string;
  definition?: WorkflowDefinition;
}

export interface StoreWorkflowScheduleRequest {
  workflow_definition_id: string;
  name: string;
  description?: string;
  cron_expression: string;
  timezone?: string;
  is_active?: boolean;
  input_data?: Record<string, unknown>;
  options?: Record<string, unknown>;
}

export interface UpdateWorkflowScheduleRequest {
  workflow_definition_id?: string;
  name?: string;
  description?: string;
  cron_expression?: string;
  timezone?: string;
  is_active?: boolean;
  input_data?: Record<string, unknown>;
  options?: Record<string, unknown>;
}

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

export const workflowSchedulesService = createCrudService<
  WorkflowSchedule,
  StoreWorkflowScheduleRequest,
  UpdateWorkflowScheduleRequest
>('/admin/workflows/schedules');
